import { QUIZ_TYPE } from "@constants";

export const getTotalAnswered = (questions = []) => {
  return questions.filter(
    (ques) => ques.userAnswer && ques.userAnswer.length !== 0
  ).length;
};

export const getQuizResult = (questions = [], passingScore = 0) => {
  let totalScore = 0;
  let totalCorrectAnswer = 0;
  let maxScore = 0;
  for (let i = 0; i < questions.length; i++) {
    if (isCorrectAnswer(questions[i])) {
      totalScore += questions[i].score;
      totalCorrectAnswer += 1;
    }
    maxScore += questions[i].score;
  }
  const minScore = Math.round((passingScore * maxScore) / 100);

  return {
    totalScore,
    maxScore,
    minScore,
    totalCorrectAnswer,
    totalQuestions: questions.length,
    isPass: totalScore >= minScore,
  };
};

export const getPassingScore = (questions = [], passingScore = 0) => {
  const maxScore = questions.reduce((sum, ques) => sum + ques.score, 0);
  const minScore = Math.round((passingScore * maxScore) / 100);

  return {
    maxScore,
    minScore,
  };
};

export function isCorrectAnswer(question) {
  if (!question.userAnswer || question.userAnswer.length === 0) return false;

  if (
    question.type === QUIZ_TYPE.SINGLE_LINE ||
    question.type === QUIZ_TYPE.MULTI_LINE
  ) {
    // change both to lower case and compare
    return (
      question.userAnswer[0].trim().toLowerCase() ==
      question.textAnswer.trim().toLowerCase()
    );
  } else if (question.type === QUIZ_TYPE.SINGLE_CHOICE) {
    // get 1 correct option and compare
    const correctOption = question.options.find(
      (opt) => opt.isCorrectAnswer === true
    );
    if (!correctOption) return false;
    return question.userAnswer[0] == correctOption.id;
  } else if (question.type === QUIZ_TYPE.MULTI_CHOICE) {
    // get list correct options and compare length - value
    const correctOptionList = question.options.filter(
      (opt) => opt.isCorrectAnswer === true
    );
    if (
      !correctOptionList ||
      correctOptionList.length === 0 ||
      correctOptionList.length !== question.userAnswer.length
    )
      return false;
    for (let i = 0; i < correctOptionList.length; i++) {
      if (!question.userAnswer.find((id) => id === correctOptionList[i].id))
        return false;
    }
    return true;
  }
  return false;
}
